import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import ShowPrice from "./showPrice";
import TariffLines from "./tariffsLines";
import HexagonInput from "@/common/customElements/HexagonInput";
import { CustomDiv, HorizontalCenterDiv, InlineDiv } from "@/common/divs";
import { SemiBoldText } from "@/common/texts";
import { useSchedule } from "@/hooks/useSchedule";
import {
  ActivityTariffAvailabilityTariffType,
  ScheduleHoursRangeVm,
} from "@/model";
import { PriceDetailType } from "@/types/components";

const SelectTariff = ({
  selectedHour,
  priceRef,
  setDisableBookButton,
  price_detail,
  tariffId,
  tariffType,
  price,
  setPrice,
}: {
  selectedHour: ScheduleHoursRangeVm;
  priceRef: React.MutableRefObject<string>;
  price_detail: React.RefObject<PriceDetailType[]>;
  setDisableBookButton: (value: boolean) => void;
  tariffId: React.MutableRefObject<number>;
  tariffType: React.MutableRefObject<string>;
  price: string;
  setPrice: (value: string) => void;
}) => {
  const { t } = useTranslation();
  const { groups, loadingTariffs } = useSchedule(selectedHour);
  const [tariffSelected, setTariffSelected] = useState<
    ActivityTariffAvailabilityTariffType | undefined
  >();

  useEffect(() => {
    setDisableBookButton(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingTariffs]);

  useEffect(() => {
    if (groups) {
      if (groups.length == 1) {
        tariffId.current = groups[0].tariffId;
        tariffType.current = groups[0].tariffType ?? "";
        setTariffSelected(groups[0].tariffType);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups]);

  return (
    <>
      <InlineDiv
        width="482px"
        paddingY="16px"
        paddingX="25px"
        className="select-tariff-container"
      >
        <SemiBoldText fontSize="18px" style={{ width: "100%" }}>
          {t("select_price_lines.traveling_way")}
        </SemiBoldText>
        {loadingTariffs && (
          <HorizontalCenterDiv
            style={{
              width: "100%",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </HorizontalCenterDiv>
        )}
        {groups &&
          groups.map((tariff) => (
            <CustomDiv key={tariff.tariffType} style={{ width: "100%" }}>
              <InlineDiv style={{ width: "100%" }}>
                <HexagonInput
                  onClick={() => {
                    if (tariffSelected === tariff.tariffType) {
                      setTariffSelected(undefined);
                    } else {
                      tariffId.current = tariff.tariffId;
                      tariffType.current = tariff.tariffType ?? "";
                      setTariffSelected(tariff.tariffType);
                    }
                  }}
                  checked={tariffSelected === tariff.tariffType}
                />
                <SemiBoldText
                  fontSize="14px"
                  style={{
                    marginLeft: "5px",
                    textTransform: "uppercase",
                  }}
                >
                  {tariff.tariffType == "INDIVIDUAL_DETAILED" ?
                    t("activity.taxes.title")
                  : tariff.tariffType == "GROUP" ?
                    t("audience.group")
                  : tariff.tariffType}
                </SemiBoldText>
              </InlineDiv>
              {tariffSelected === tariff.tariffType && (
                <TariffLines
                  selectedHour={selectedHour}
                  tariff={tariff}
                  setPrice={setPrice}
                  priceRef={priceRef}
                  price_detail={price_detail}
                  setDisableBookButton={setDisableBookButton}
                />
              )}
            </CustomDiv>
          ))}
      </InlineDiv>
      {selectedHour && <ShowPrice price={price} />}
    </>
  );
};

export default SelectTariff;
